<template>
    <page>
        <div class="shadow-25">
            <v-header :title="$t('export file')" icon="cloud download"></v-header>
            <card width="400px" style="margin: 0 auto;">

                <form class="q-pt-xs gutter-xs row" method="post" target="_blank"
                :action="`${config.appUrl}/lending-kit/export`">

                    <input type="hidden" name="partial" :value="partial">

                    <v-checkbox path="partial"
                                v-model="partial"
                                :label="$t('download only the lending kits registered after the last export.')"
                                :form="form"
                                class="col-12">
                    </v-checkbox>

                    <input type="hidden" name="associated" :value="associated">

                    <v-checkbox path="associated"
                                v-model="associated"
                                :label="$t('download only the lending kits associated to a lending point.')"
                                :form="form"
                                class="col-12">
                    </v-checkbox>

                    <div class="row justify-center col-12 q-mt-md">
                        <v-button outline
                                  :label="$t('download')"
                                  icon="cloud download"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  type="submit">
                        </v-button>
                    </div>

                </form>

            </card>
        </div>
    </page>
</template>

<script>
    export default {
        middleware: 'auth',

        metaInfo() {
            return {title: this.$T('export file')}
        },

        data() {
            return {
                config,
                partial: false,
                associated: false,
                form: {  }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/backoffice/lending-kit/export.vue